<div>
    <ng-template #helpTemplate>
        <div>
            <span>{{vm.helpText || vm.title}}</span>
        </div>
        <div *ngIf="validationErrors.length">
            <p class="text-danger" *ngFor="let ve of validationErrors">{{ve}}</p>
        </div>
    </ng-template>
    
    <mdb-checkbox  class="checkbox-teal" [disabled]="vm.isLocked" [ngModel]="checked" (ngModelChange)="modelChanged($event)" [inline]="true"
        [ngModelOptions]="{standalone: true}" 
        [mdbTooltip]="helpTemplate" [triggers]="vm.title && !vm.hideLabel ? 'hover' : ''">{{vm.title}}
        <mdb-icon *ngIf="validationErrors.length" class="text-danger" fas icon="exclamation-circle"></mdb-icon>
        <mdb-icon *ngIf="vm.isLocked" style="color: #e0e0e0;" fas icon="lock"></mdb-icon>
        <mdb-icon *ngIf="vm.helpText" fas icon="question-circle" class="icon-help"></mdb-icon>
    </mdb-checkbox>
</div>
